import { render, staticRenderFns } from "./AppFooterAccount.vue?vue&type=template&id=60cf766d&scoped=true"
import script from "./AppFooterAccount.vue?vue&type=script&lang=ts"
export * from "./AppFooterAccount.vue?vue&type=script&lang=ts"
import style0 from "./AppFooterAccount.vue?vue&type=style&index=0&id=60cf766d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf766d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
